import React from "react";
import { Input, Label } from "reactstrap"

const CustomCheckboxWithLabel = ({ value, onClick, id, label, labelStyle, customstyle }) => {
    return (
        id?.includes("Hide") ? <div className="form-check" style={customstyle ? customstyle : null}>
            <Input
                type="checkbox"
                checked={value}
                className="form-check-input"
                id={id}
                onClick={onClick}
            />
            <Label className="form-check-label" htmlFor={id} style={labelStyle ? labelStyle : null}>
                {label}
            </Label>
        </div>
            : <div className="form-check">
                <Input
                    type="checkbox"
                    defaultChecked={value}
                    className="form-check-input"
                    id={id}
                    onChange={onClick}
                />
                <Label className="form-check-label" htmlFor={id} >{label}</Label>
            </div>
    )
}

export default CustomCheckboxWithLabel;